import React, { useState } from "react";
import {
  StyledUploaderFilesItem,
  StyledUploaderFilesItemSize,
  StyledUploaderFilesItemText
} from "./UploadFileFormik.styled";
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { CircularProgress, Tooltip } from "@mui/material";
import { useAppDispatch, useAppSelector } from "commons/store/hooks";
import { useTranslation } from "react-i18next";
import { selectUserProfile } from "core/redux/userSlice";
import { deleteOne } from "features/ecrf/redux/elementResourceTransferSlice";
import { formatBytes } from "lib";
import { useSnackbar } from "notistack";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";

// ==============================================================
interface Props {
  name: string;
  size: string;
  link?: string;
  id: string;
  isUploading?: boolean;
  removeRow?: (id: string) => void;
  update?: (id: string) => void;
  dataId?: string;
}
// ==============================================================

const FileItem = ({ name, size, link, id, isUploading, removeRow, update, dataId }: Props) => {
  const dispatch = useAppDispatch();
  const userProfile = useAppSelector(selectUserProfile);
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [deleting, setDeleting] = useState(false);

  const deleteFile = async (id: string) => {
    if (userProfile.role !== 'ROLE_ADMIN') {
      return;
    }

    setDeleting(true);

    try {
      await dispatch(deleteOne(id));
      update?.(dataId || '-');
    } catch (error: any) {
      enqueueSnackbar(error?.detail, { variant: 'warning' });
    }

    setDeleting(false);
  };

  return (
    <StyledUploaderFilesItem isAdmin={userProfile.role === 'ROLE_ADMIN'}>
      <InsertDriveFileOutlinedIcon />

      <Tooltip title={name} arrow>
        <StyledUploaderFilesItemText>
          {name || t('name')}
        </StyledUploaderFilesItemText>
      </Tooltip>

      <StyledUploaderFilesItemSize>
        {formatBytes(size) || t('size')}
      </StyledUploaderFilesItemSize>

      {/* <--- Remove file from selected list ---> */}
      {!isUploading && !link && size && (
        <Tooltip title={t('remove-from-list')} arrow>
          <StyledUploaderFilesItemSize
            onClick={() => {
              if (removeRow) {
                removeRow(name)
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            <ClearRoundedIcon style={{ fontSize: '15px' }}/>
          </StyledUploaderFilesItemSize>
        </Tooltip>
      )}

      {isUploading && <CircularProgress size={22} />}

      {link && userProfile.role === "ROLE_ADMIN" && (
        <Tooltip title={t('delete-file')} arrow>
          <StyledUploaderFilesItemSize
            onClick={() => deleteFile(id)}
            style={{ cursor: 'pointer' }}
          >
            {deleting ? <CircularProgress size={14}/> : <DeleteRoundedIcon style={{ fontSize: '15px' }} />}
          </StyledUploaderFilesItemSize>
        </Tooltip>
      )}
    </StyledUploaderFilesItem>
  );
};

export default FileItem;